/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const operators = [
  { label: 'ALL', description: null },
  { label: 'AND', description: null },
  { label: 'ANY', description: null },
  { label: 'BETWEEN', description: null },
  { label: 'CONTAINS', description: null },
  { label: 'CROSS', description: null },
  { label: 'EXCEPT', description: null },
  { label: 'EXISTS', description: null },
  { label: 'FULL', description: null },
  { label: 'IN', description: null },
  { label: 'INNER', description: null },
  { label: 'INTERSECT', description: null },
  { label: 'IS', description: null },
  { label: 'JOIN', description: null },
  { label: 'LEFT', description: null },
  { label: 'LIKE', description: null },
  { label: 'MATCHED', description: null },
  { label: 'NOT', description: null },
  { label: 'NULL', description: null },
  { label: 'OR', description: null },
  { label: 'OUTER', description: null },
  { label: 'RIGHT', description: null },
  { label: 'SOME', description: null },
  { label: 'UNION', description: null },
];
